import PropTypes from 'prop-types'

import useIsMobile from '../../../hooks/useIsMobile'
import Content from './Content'
import BasicInfoSection from './Content/BasicInfoSection'
import DesktopLayout from '../../layout/DesktopSecondary'
import MobileLayout from '../../layout/MobileFullScreen'

const ShippingDetail = ({
  isLoading,
  data,
  state,
  trackingLineData,
  activateReturnShippingInfo,
  setScheduledPickupShippingsInfo,
  cancelActivateReturn,
  showFullTrackingButton,
  onOpenFullTrackingDrawer,
  setIncidentBeingSolved
}) => {
  const isMobile = useIsMobile()

  const Layout = isMobile ? MobileLayout : DesktopLayout

  return (
    <Layout isLoading={isLoading} basicInfo={<BasicInfoSection data={data} />}>
      <Content
        data={data}
        state={state}
        cancelActivateReturn={cancelActivateReturn}
        activateReturnShippingInfo={activateReturnShippingInfo}
        trackingLineData={trackingLineData}
        setScheduledPickupShippingsInfo={setScheduledPickupShippingsInfo}
        showFullTrackingButton={showFullTrackingButton}
        onOpenFullTrackingDrawer={onOpenFullTrackingDrawer}
        setIncidentBeingSolved={setIncidentBeingSolved}
      />
    </Layout>
  )
}

ShippingDetail.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.object,
  state: PropTypes.object,
  activateReturnShippingInfo: PropTypes.object,
  cancelActivateReturn: PropTypes.func,
  trackingLineData: PropTypes.object,
  showFullTrackingButton: PropTypes.bool,
  onOpenFullTrackingDrawer: PropTypes.func,
  setIncidentBeingSolved: PropTypes.func
}

export default ShippingDetail
